module.exports = __webpack_public_path__ + "bin/80aab3123d88949de62eadb752021e6c.otf";